export interface PortfolioItem {
  id: number;
  category: 'black-gray' | 'minimal' | 'color' | 'lettering' | 'geometric';
  artist: string;
  bodyPart: string;
  duration: string;
  style: string;
  imageUrl: string;
  aspectRatio: 'portrait' | 'landscape' | 'square';
}

export const portfolioItems: PortfolioItem[] = [
  {
    id: 1,
    category: 'black-gray',
    artist: 'MINJUN LEE',
    bodyPart: '팔뚝',
    duration: '4시간',
    style: 'Black & Gray',
    imageUrl: 'https://public.readdy.ai/ai/img_res/719f8f44f032c8b20f4a078d93ef83cc.jpg',
    aspectRatio: 'portrait',
  },
  {
    id: 2,
    category: 'minimal',
    artist: 'SOYEON PARK',
    bodyPart: '손목',
    duration: '1시간',
    style: 'Minimal',
    imageUrl: 'https://readdy.ai/api/search-image?query=minimalist%20fine%20line%20tattoo%20on%20wrist%2C%20delicate%20botanical%20illustration%2C%20single%20needle%20technique%2C%20clean%20white%20studio%20background%2C%20elegant%20and%20simple%2C%20close%20up%20macro%20photography&width=400&height=400&seq=p2&orientation=squarish',
    aspectRatio: 'square',
  },
  {
    id: 3,
    category: 'color',
    artist: 'JIWON CHOI',
    bodyPart: '어깨',
    duration: '6시간',
    style: 'Color',
    imageUrl: 'https://readdy.ai/api/search-image?query=vibrant%20color%20tattoo%20on%20shoulder%2C%20watercolor%20style%20floral%20design%2C%20vivid%20pigments%2C%20professional%20tattoo%20studio%2C%20artistic%20composition%2C%20bright%20and%20saturated%20colors%2C%20clean%20white%20background&width=400&height=300&seq=p3&orientation=landscape',
    aspectRatio: 'landscape',
  },
  {
    id: 4,
    category: 'lettering',
    artist: 'HYUNWOO KIM',
    bodyPart: '쇄골',
    duration: '2시간',
    style: 'Lettering',
    imageUrl: 'https://readdy.ai/api/search-image?query=elegant%20script%20lettering%20tattoo%20on%20collarbone%2C%20fine%20calligraphy%20style%2C%20black%20ink%20on%20fair%20skin%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20close%20up%20photography&width=400&height=560&seq=p4&orientation=portrait',
    aspectRatio: 'portrait',
  },
  {
    id: 5,
    category: 'geometric',
    artist: 'EUNJI SHIN',
    bodyPart: '등',
    duration: '8시간',
    style: 'Geometric',
    imageUrl: 'https://readdy.ai/api/search-image?query=intricate%20geometric%20tattoo%20on%20back%2C%20sacred%20geometry%20mandala%20design%2C%20precise%20linework%2C%20black%20ink%2C%20professional%20tattoo%20photography%2C%20white%20studio%20background%2C%20symmetrical%20pattern&width=400&height=400&seq=p5&orientation=squarish',
    aspectRatio: 'square',
  },
  {
    id: 6,
    category: 'black-gray',
    artist: 'TAEHYUN RYU',
    bodyPart: '종아리',
    duration: '5시간',
    style: 'Black & Gray',
    imageUrl: 'https://readdy.ai/api/search-image?query=realistic%20black%20and%20gray%20portrait%20tattoo%20on%20calf%2C%20photorealistic%20shading%20technique%2C%20detailed%20face%20tattoo%2C%20professional%20studio%20lighting%2C%20artistic%20tattoo%20photography&width=400&height=560&seq=p6&orientation=portrait',
    aspectRatio: 'portrait',
  },
  {
    id: 7,
    category: 'minimal',
    artist: 'SOYEON PARK',
    bodyPart: '발목',
    duration: '45분',
    style: 'Minimal',
    imageUrl: 'https://readdy.ai/api/search-image?query=tiny%20minimalist%20tattoo%20on%20ankle%2C%20simple%20geometric%20shape%2C%20single%20needle%20fine%20line%2C%20clean%20white%20background%2C%20delicate%20and%20elegant%2C%20macro%20photography&width=400&height=300&seq=p7&orientation=landscape',
    aspectRatio: 'landscape',
  },
  {
    id: 8,
    category: 'color',
    artist: 'JIWON CHOI',
    bodyPart: '팔뚝',
    duration: '7시간',
    style: 'Color',
    imageUrl: 'https://readdy.ai/api/search-image?query=japanese%20style%20color%20tattoo%20sleeve%2C%20koi%20fish%20and%20cherry%20blossom%2C%20vibrant%20traditional%20colors%2C%20professional%20tattoo%20studio%20photography%2C%20artistic%20composition&width=400&height=560&seq=p8&orientation=portrait',
    aspectRatio: 'portrait',
  },
  {
    id: 9,
    category: 'geometric',
    artist: 'MINJUN LEE',
    bodyPart: '가슴',
    duration: '6시간',
    style: 'Geometric',
    imageUrl: 'https://readdy.ai/api/search-image?query=geometric%20chest%20tattoo%2C%20dotwork%20and%20linework%20combination%2C%20symmetrical%20design%2C%20black%20ink%2C%20professional%20studio%20lighting%2C%20artistic%20tattoo%20photography%2C%20clean%20white%20background&width=400&height=400&seq=p9&orientation=squarish',
    aspectRatio: 'square',
  },
  {
    id: 10,
    category: 'lettering',
    artist: 'HYUNWOO KIM',
    bodyPart: '팔뚝',
    duration: '3시간',
    style: 'Lettering',
    imageUrl: 'https://readdy.ai/api/search-image?query=blackletter%20gothic%20script%20tattoo%20on%20forearm%2C%20ornate%20typography%2C%20black%20ink%20calligraphy%2C%20professional%20tattoo%20studio%2C%20artistic%20photography%2C%20clean%20background&width=400&height=300&seq=p10&orientation=landscape',
    aspectRatio: 'landscape',
  },
  {
    id: 11,
    category: 'black-gray',
    artist: 'EUNJI SHIN',
    bodyPart: '어깨',
    duration: '5시간',
    style: 'Black & Gray',
    imageUrl: 'https://readdy.ai/api/search-image?query=black%20and%20gray%20floral%20tattoo%20on%20shoulder%2C%20realistic%20rose%20and%20peony%2C%20fine%20shading%20technique%2C%20professional%20studio%20photography%2C%20elegant%20and%20detailed&width=400&height=560&seq=p11&orientation=portrait',
    aspectRatio: 'portrait',
  },
  {
    id: 12,
    category: 'minimal',
    artist: 'TAEHYUN RYU',
    bodyPart: '손가락',
    duration: '30분',
    style: 'Minimal',
    imageUrl: 'https://readdy.ai/api/search-image?query=minimalist%20finger%20tattoo%2C%20tiny%20simple%20symbol%2C%20fine%20line%20single%20needle%2C%20close%20up%20macro%20photography%2C%20white%20background%2C%20delicate%20and%20precise&width=400&height=400&seq=p12&orientation=squarish',
    aspectRatio: 'square',
  },
];
